import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { getCurrency } from 'lib/utilities/Price';
import React, { useContext } from 'react';
import styled from 'styled-components';

const AviosBannerContainer = styled.div`
	margin-bottom: 30px;
`;

function AviosBanner() {
	// TODO: Remove this when the CruiseSearchContext is properly typed
	const { locale } = useContext(CruiseSearchContext) as unknown as { locale: { country: string; language: string; currency: string } };
	const currency = getCurrency(locale.currency);

	/* eslint-disable */
	// @ts-ignore
	import('@rcg/avios-info-modal-component');
	/* eslint-enable */

	return (
		<AviosBannerContainer>
			{/* @ts-expect-error avios-info-modal-component is a web component*/}
			<avios-info-modal-component
				country={locale.country}
				language={locale.language}
				currency={currency.symbol}
				page-name="cruiseSearch"
				large-version="true"
			>
				{/* @ts-expect-error avios-info-modal-component is a web component*/}
			</avios-info-modal-component>
		</AviosBannerContainer>
	);
}

export default AviosBanner;
